import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { fromJS, List, Map } from 'immutable';
import { IFormMasterBuilder } from '../../../form-master/form-master.interface';
import { CustomField } from '../../../settings-data/sub-models/custom-field.model';

@Injectable()
export class AddAdditionalFieldsBuilder implements IFormMasterBuilder {
  FORM_KEYS = {};

  constructor(private _formBuilder: FormBuilder) {}

  buildForm(additionalFields: List<CustomField>): FormGroup {
    const formGroup = {};

    additionalFields.forEach((field: CustomField, index: number) => {
      formGroup[this.buildFormKeyForField(index)] = [
        field.value,
        Validators.maxLength(1000),
      ];
    });

    return this._formBuilder.group(formGroup);
  }

  buildFormKeyForField(position: number): string {
    return `${position}AdditionalField`;
  }

  buildCustomFieldsProps(
    additionalFields: List<CustomField>,
    additionalFieldsInfo: Map<string, any>
  ): List<Map<string, any>> {
    const result = additionalFields.map(
      (additionalField: CustomField, index: number) => {
        return fromJS({
          [CustomField.KEYS.KEY]: additionalField.key,
          [CustomField.KEYS.VALUE]: additionalFieldsInfo.get(
            this.buildFormKeyForField(index)
          ),
        });
      }
    );

    return result as List<Map<string, any>>;
  }
}
